import React, { useState, useEffect } from "react";
import styled from "styled-components";
import colorsArray from "../data/colorsArray.json";
import ReactFontPicker from "./ReactFontPickerNeu";

const fontBlacklist = [
  "Aladin-Regular",
  "Alba",
  "Alpha54",
  "Berliner-Wand",
  "BernerBasisschrift1",
  "Berolina",
  "Bitwise",
  "Blankenburg",
  "Bloody",
  "BoecklinsUniverse",
  "BombeCAT",
  "BubblerOne",
  "C-BOX",
  "CariocaScriptPro",
  "Chewy",
  "Classica-Bold",
  "Classica",
  "Courgette",
  "Damion-Regular",
  "Dogv2c",
  "GangOfThree",
  "LetsGoDigital",
  "Megadeth",
  "Nautilus",
  "Niconne",
  "OneTrickPony-OT",
  "PassionOne",
  "Playball",
  "PleasinglyPlump",
  "SpyAgency3",
  "Wolf4b",
  "Wolf4bi",
  "Xenogears",
];

const ModalStyle = styled.div`
  transform: translate(0%, -50%);
  background-color: white;
  z-index: 1000;
  border: 3px solid rgb(89, 113, 130);
  z-index: 2;
`;

const OverlayStyle = styled.div`
  position: fixed;
  top: ${(props) => props.scrollPosition}px;
  @media screen and (max-width: 768px) {
    top: 0px;
  }
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const Header = styled.div`
  background: white;
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
  padding-right: 8px;

  p {
    font-weight: 700;
    padding-left: 16px;
    font-size: large;
    margin-top: 0px;
    margin-bottom: 8px;
  }
  span {
    font-size: large;
    font-weight: 700;
  }
`;
const Content = styled.div`
  background: rgb(247, 247, 247);
  min-height: 62px;
`;

const ModalButton = styled.div`
  background-color: #515151;
  color: #fff;
  height: 30px;
  position: relative;
  z-index: 0;
  ${
    "" /* top: -3px;
  right: -3px; */
  }
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  p {
    color: #fff;
    position: relative;
    bottom: 2px;
    left: 2px;
  }
`;

const Element = styled.div`
  margin-left: 16px;
  margin-right: 16px;

  > div.upper {
    color: white;
  }
`;

const Wrapper = styled.div`
  flex-wrap: wrap;
`;

export default function TextBearbeitung(props) {
  let colors;
  if (props.folienTyp === "Hochwertig") {
    colors = [
      "#F48418",
      "#FB9301",
      "#FD9B0B",
      "#E4860D",
      "#D1850A",
      "#F4A002",
      "#FDA617",
      "#F8AF0A",
      "#FABE09",
      "#FFE934",
      "#69000F",
      "#8E0E01",
      "#970005",
      "#990B07",
      "#CD0001",
      "#C90E08",
      "#C60205",
      "#D40606",
      "#D20301",
      "#E40A03",
      "#D20300",
      "#D90D07",
      "#DD1603",
      "#F02603",
      "#F02505",
      "#F93E15",
      "#F22E0C",
      "#F74B04",
      "#E93800",
      "#480019",
      "#7E0307",
      "#581045",
      "#44184C",
      "#3B266E",
      "#655194",
      "#B88CB3",
      "#C50B49",
      "#C81356",
      "#D6396C",
      "#EF67A7",
      "#111823",
      "#001836",
      "#0B1536",
      "#0D173C",
      "#002258",
      "#132E5B",
      "#002B6E",
      "#01155B",
      "#051F6E",
      "#032070",
      "#0E237D",
      "#001771",
      "#032799",
      "#011E7C",
      "#003773",
      "#014A6D",
      "#003687",
      "#00489A",
      "#003789",
      "#004E9A",
      "#015BB8",
      "#0053AC",
      "#2F70B9",
      "#026EAD",
      "#0173BC",
      "#0083C8",
      "#1FA6DD",
      "#65879A",
      "#004E72",
      "#01779B",
      "#0093A7",
      "#14C7C6",
      "#68D3E7",
      "#003E23",
      "#004229",
      "#004517",
      "#00541D",
      "#016753",
      "#01703D",
      "#00753F",
      "#007A42",
      "#018454",
      "#008C3C",
      "#009B1B",
      "#4A9D36",
      "#45291E",
      "#422516",
      "#4F331F",
      "#52020E",
      "#B44C17",
      "#6E3510",
      "#9A683F",
      "#9E755A",
      "#DCAE8C",
      "#E4C194",
      "#FAD3A8",
      "#E9D7BD",
      "#ECD8BF",
      "#000000",
      "#2E2F31",
      "#373C3F",
      "#595E61",
      "#616F70",
      "#75828A",
      "#85898C",
      "#8A8F8C",
      "#97999B",
      "#C5C8CB",
      "#DCE2E9",
      "#FFFFFF",
      "#838180",
      "#885D3C",
      "#292F2C",
      "#2D3138",
    ];
  } else if (props.folienTyp === "MattPremium") {
    colors = ["#FFFFFF", "#000000"];
  } else if (props.folienTyp === "Milchglas") {
    colors = ["#EDECEC", "#D2CFCF"];
  } else {
    colors = [
      "#000000",
      "#FFFFFF",
      "#F48418",
      "#E8A908",
      "#FCC517",
      "#F8B725",
      "#F1E702",
      "#69000F",
      "#7F0400",
      "#A50409",
      "#CD0102",
      "#D72428",
      "#E41C05",
      "#DC4824",
      "#FA4019",
      "#441853",
      "#685292",
      "#B48FBD",
      "#EC2676",
      "#EA80B3",
      "#141E3A",
      "#16143A",
      "#0D264F",
      "#032070",
      "#032799",
      "#003575",
      "#023382",
      "#003D83",
      "#014A99",
      "#0055A2",
      "#006BB9",
      "#0083C8",
      "#1FA6DD",
      "#01779B",
      "#0093A7",
      "#14C7C6",
      "#0E3F2C",
      "#024A35",
      "#017246",
      "#00763F",
      "#028542",
      "#0C9016",
      "#69BD47",
      "#45291D",
      "#B85C27",
      "#C7763F",
      "#AC885F",
      "#C7B69F",
      "#FCD9AB",
      "#373C3F",
      "#616F70",
      "#707D80",
      "#7C8486",
      "#BEC2C7",
      "#828688",
      "#866C2C",
      "#7F3D21",
    ];
  }

  const options = [];
  for (let i = 1; i <= 100; i++) {
    const size = 16 + (i - 1) * 4;
    options.push(
      <option key={i} value={`${size}px`}>
        {i}
      </option>
    );
  }

  const [scrollPosition, setScrollPosition] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFontSizeModalOpen, setIsFontSizeModalOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset || document.documentElement.scrollTop;
      setScrollPosition(position);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openModal = () => {
    if (!!props.link) {
      window.open(props.link, "_blank");
      return;
    }
    setIsModalOpen(true);
    document.body.style.overflow = "hidden"; // Inhibit scroll
  };

  const openFontSizeModal = () => {
    if (!!props.link) {
      window.open(props.link, "_blank");
      return;
    }
    setIsFontSizeModalOpen(true);
    document.body.style.overflow = "hidden"; // Inhibit scroll
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsFontSizeModalOpen(false);
    document.body.style.overflow = "auto"; // Enable scroll
  };

  // calculate line height
  console.log("aktige: ", typeof props.aktiveZeile);

  const printHeight =
    props.lastUserInputField == "hoehe"
      ? props.lastUserInput
      : props.lastUserInput / props.ratio;

  console.log({ printHeight });
  let lineHeightInCm = "Bitte Zeile auswählen";
  if (typeof props.aktiveZeile === "string") {
    lineHeightInCm =
      "ca. " +
      (
        (printHeight / props.svgHeight) *
        props.pathMeasures[props.aktiveZeile - 1].height
      ).toFixed(1) +
      " cm";
  }

  console.log({
    lineHeightInCm,
    zeile: props.aktiveZeile,
    meas: props.pathMeasures,
    svgHeight: props.svgHeight,
  });
  // svgHeight={this.state.svgHeight}
  // pathMeasures={this.state.pathMeasures}
  // lastUserInputField={this.state.lastUserInputField}
  // lastUserInput={this.state.lastUserInput}
  // ratio={this.state.ratio}

  return (
    <>
      <Wrapper className="flex">
        <Element className="element">
          <div className="upper">Zeile bearbeiten</div>
          <div className="lower">
            <select
              id="zeile"
              onChange={(e) => {
                props.setAktiveZeile(e.target.value);
              }}
            >
              <option value={0}>Alle</option>
              {props.zeilen.map((item, key) => {
                return (
                  <option key={key} value={item}>
                    {item}
                  </option>
                );
              })}
            </select>
          </div>
        </Element>
        <Element className="element">
          <div className="upper">Zeilenhöhe</div>
          <div className="lower">
            <p>{lineHeightInCm}</p>
          </div>
        </Element>
        <Element className="element">
          <div className="upper">Schriftart</div>
          <div className="lower">
            <ReactFontPicker
              reactFontPicker={props.reactFontPicker}
              font={props.fullInfo[props.aktiveZeile - 1].font}
            />
          </div>
        </Element>

        <Element className="element">
          <div className="upper">Textstil ändern</div>
          <div className="lower">
            <div
              className="bold text-align-logo mk-bold"
              style={{
                opacity: !fontBlacklist.includes(
                  props.fullInfo[props.aktiveZeile - 1].font
                )
                  ? 1
                  : 0.5,
              }}
              onClick={
                fontBlacklist.includes(
                  props.fullInfo[props.aktiveZeile - 1].font
                )
                  ? null
                  : props.setTextFormat
              }
            ></div>
            <div
              className="italic text-align-logo mk-italic"
              style={{
                opacity: !fontBlacklist.includes(
                  props.fullInfo[props.aktiveZeile - 1].font
                )
                  ? 1
                  : 0.5,
              }}
              onClick={
                fontBlacklist.includes(
                  props.fullInfo[props.aktiveZeile - 1].font
                )
                  ? null
                  : props.setTextFormat
              }
            ></div>
          </div>
        </Element>
        <Element className="element">
          <div className="upper">Farben</div>
          <div className="lower absolute">
            <div
              className="color-picker-mk"
              onClick={props.toggleColorModal}
              style={{
                backgroundColor: props.hexcode,
              }}
            ></div>
            {props.colorModalIsShown ? (
              <div className="color-picker-wrapper-mk">
                {colorsArray
                  ?.filter((c) => colors.includes(c.hexcode))
                  .map((color, index) => {
                    return (
                      <div
                        onClick={() => props.colorClicked(color.hexcode)}
                        id={index}
                        className="color-modal-mk"
                        style={{
                          backgroundColor: color.hexcode,
                          color: color.complementaryColor,
                        }}
                      >
                        {color.name}
                      </div>
                    );
                  })}
              </div>
            ) : null}
          </div>
        </Element>
        <Element className="element">
          <div className="upper">
            Buchstabengröße&nbsp;
            <span
              onClick={() => openFontSizeModal()}
              style={{ cursor: "pointer" }}
            >
              {"?"}
            </span>
          </div>
          <div className="lower">
            <select
              id="schriftgroesse"
              value={
                props.fullInfo[props.aktiveZeile - 1].fontSize.includes("px")
                  ? props.fullInfo[props.aktiveZeile - 1].fontSize
                  : props.fullInfo[props.aktiveZeile - 1].fontSize + "px"
              }
              onChange={(e) => {
                props.setFontSize(e);
              }}
            >
              {options}
            </select>
          </div>
        </Element>
        <Element className="element">
          <div className="upper">Ausrichtung</div>
          <div className="lower">
            <div
              className="active left text-align-logo mk-left"
              onClick={props.setTextAlign}
            ></div>
            <div
              className="center text-align-logo mk-center"
              onClick={props.setTextAlign}
            ></div>
            <div
              className="right text-align-logo mk-right"
              onClick={props.setTextAlign}
            ></div>
          </div>
        </Element>
        <Element className="element">
          <div className="upper">Zeilenabstand</div>
          <div className="lower">
            <select
              id="zeilenabstand"
              onChange={props.setLineHeight}
              value={props.zeilenabstand}
            >
              <option value="-162">0</option>
              <option value="-130">1</option>
              <option value="-98">2</option>
              <option value="-66">3</option>
              <option value="-34">4</option>
              <option value="-2">5</option>
              <option value="30">6</option>
              <option value="62">7</option>
              <option value="94">8</option>
              <option value="126">9</option>
              <option value="158">10</option>
              {/* <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>
              <option value="32">32</option>
              <option value="33">33</option>
              <option value="34">34</option>
              <option value="35">35</option>
              <option value="36">36</option>
              <option value="37">37</option>
              <option value="38">38</option>
              <option value="39">39</option>
              <option value="40">40</option>
              <option value="41">41</option>
              <option value="42">42</option>
              <option value="43">43</option>
              <option value="44">44</option>
              <option value="45">45</option>
              <option value="46">46</option>
              <option value="47">47</option>
              <option value="48">48</option>
              <option value="49">49</option>
              <option value="50">50</option> */}
            </select>
          </div>
        </Element>

        <Element className="element">
          <div className="upper">
            {"Spiegeln"}&nbsp;
            <span onClick={() => openModal()} style={{ cursor: "pointer" }}>
              {"?"}
            </span>
          </div>
          <div className="lower">
            <input
              id="mirror-checkbox"
              className="mk-input"
              type="checkbox"
              onChange={props.toggleMirror}
            ></input>
          </div>
        </Element>
      </Wrapper>
      {isModalOpen ? (
        <>
          <OverlayStyle
            onClick={() => closeModal()}
            id="overlay"
            scrollPosition={scrollPosition}
          >
            <ModalStyle id="modal">
              <Header>
                <h1 style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                  Spiegeln
                </h1>
                <ModalButton onClick={() => closeModal()}>
                  <span>X</span>
                </ModalButton>
              </Header>
              <Content>
                Wählen sie diese Option, wenn Sie die Folie von Innen auf Glas
                aufkleben und die Schrift von Außen lesbar sein soll.
              </Content>
            </ModalStyle>
          </OverlayStyle>
        </>
      ) : null}
      {isFontSizeModalOpen ? (
        <>
          <OverlayStyle
            onClick={() => closeModal()}
            id="overlay"
            scrollPosition={scrollPosition}
          >
            <ModalStyle id="modal">
              <Header>
                <h1 style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                  Schriftgröße
                </h1>
                <ModalButton onClick={() => closeModal()}>
                  <span>X</span>
                </ModalButton>
              </Header>
              <Content>
                Hier stellen Sie die relative Schriftgröße für die ausgewählte
                Zeile aus. Die Größe der Klebefolie stellen Sie bei 'Abmessung
                der Folie' ein.
              </Content>
            </ModalStyle>
          </OverlayStyle>
        </>
      ) : null}
    </>
  );
}
